import { render } from "./properties.vue?vue&type=template&id=44e7c2c6&scoped=true"
import script from "./properties.vue?vue&type=script&lang=js"
export * from "./properties.vue?vue&type=script&lang=js"

import "./properties.vue?vue&type=style&index=0&id=44e7c2c6&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e7c2c6"]])

export default __exports__